/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createEnum, EnumSet } from '@gh/core-data';

export const DashboardWidgetsType = createEnum('DASHBOARD_WIDGETS_TYPE', {
  CORPORATE: 'CORPORATE',
  MASTER: 'MASTER',
  FRANCHISEE: 'FRANCHISEE',
  SALESPERSON: 'SALESPERSON',
});

export type DashboardWidgetsType = EnumSet<typeof DashboardWidgetsType>;

export const DashboardWidgetsCode = createEnum('DASHBOARD_WIDGETS_CODE', {
  averagePreconstructionBuildTimes: 'JOB_TIMES',
  grossAndNetProfit: 'GP_AND_NP',
  averageBuildTime: 'BUILD_TIMES',
  salesLeadsBudgets: 'MONTHLY_SALES',
  salespersonTotal: 'NO_OF_SALESPEOPLE',
  monthlySalesSlabs: 'SALES_AND_SLABS',
  averageContractPrice: 'AVG_CONTRACT_PRICE',
  averageHouseCostChange: 'AVG_HOUSE_COST',
  grossProfitAndOverheads: 'GP_VS_OVERHEADS',
  preconstructionBuildTimes: 'LONGEST_JOBS',
  maintenanceTasksOverdue: 'OVERDUE_WARRANTY_TASKS',
  conversionRates: 'CONVERSION_RATES',
  averageTimeFromSfToDeposit: 'AVG_TIME_TO_CLOSE',
  topCustomersByPriority: 'HOTTEST_LEADS',
  topCustomersByEarliestContact: 'CUSTOMERS_UNCONTACTED',
  priorityAndStage: 'SALES_FOLDERS',
});

export type DashboardWidgetsCode = EnumSet<typeof DashboardWidgetsCode>;

export const DashboardChartType = createEnum('DASHBOARD_CHART_TYPE', {
  Leads: 'LEADS',
  LeadsBudgets: 'LEADS_BUDGETS',
  Sales: 'SALES',
  SalesBudgets: 'SALES_BUDGETS',
  SalesPrior: 'SALES_PRIOR',
  Slab: 'SLAB',
  SlabPrior: 'SLAB_PRIOR',
  Preconstruction: 'PRE_CONSTRUCTION',
  Build: 'BUILD',
  GrossProfit: 'GROSS_PROFIT',
  NetProfit: 'NET_PROFIT',
});

export type DashboardChartType = EnumSet<typeof DashboardChartType>;

export type DashboardAverageItem = {
  label: string;
  value: number;
  isMain: boolean;
  format: string;
  prefix?: string;
  suffix?: string;
  subtitle?: string;
  arrowUp?: boolean;
  arrowDown?: boolean;
};
